<template>
  <el-form-item label="toolTip辅助指标" label-width="110px">
    <el-switch v-model="prop.assistTip" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="显示提示语">
    <el-switch v-model="prop.tipShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="区域限制">
    <div class="flex vcenter">
      <el-switch v-model="prop.tipConfine" size="small"></el-switch>

      <span
          style="margin-left:4px;padding-top: 2px">
        <el-tooltip
            content="是否将 tooltip 框限制在图表的区域内。当图表外层的 dom 被设置为 'overflow: hidden'，或者窄屏，导致 tooltip 超出外界被截断时，此配置比较有用。指标卡环图默认开启"
            placement="top"
        >
        <el-icon>
          <Warning></Warning>
        </el-icon>
      </el-tooltip>
      </span>
    </div>
  </el-form-item>
  <el-form-item label="提示语背景">
    <colorPicker v-model="prop.tipBackgroundColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示辅助指标" size="small">
    <el-switch v-model="prop.tipSubShow"></el-switch>
  </el-form-item>
  <el-form-item label="提示语内容">
    <el-checkbox-group v-model="prop.tipContent">
      <el-checkbox label="维度值"/>
      <el-checkbox label="指标名"/>
      <el-checkbox label="指标值"/>
      <el-checkbox label="辅助指标名" :disabled="!prop.tipSubShow"/>
      <el-checkbox label="辅助指标值" :disabled="!prop.tipSubShow"/>
    </el-checkbox-group>
  </el-form-item>
  <el-form-item label="提示语字号">
    <el-input-number v-model="prop.tipFontSize" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="提示语字色">
    <colorPicker v-model="prop.tipColor"></colorPicker>
  </el-form-item>
</template>
<script setup>
import colorPicker from "./color-picker.vue";
import {Warning} from "@element-plus/icons-vue";

let props = defineProps({
  prop: {},
});
</script>
<style scoped>
</style>